import React, { useState, useEffect, useContext, useCallback } from "react";
import { Button, Table, notification, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import MeetingForm from "../../components/Forms/MeetingForm";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import DeleteMeetingDialog from "../../components/DeleteMeetingDialog";
import LoadingModal from "../../utils/LoadingModal";
import formatTimestamp from "../../utils/FormatTimestamp";
import { Link } from "react-router-dom";
import { MEETING_STATUS } from "../../utils/Constants";

const PAGE_SIZE = 15;

const ClosedMeetingList = () => {
  const globals = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  const [messageVisible, setMessageVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const userRole = globals.userRole;
  const userEmail = globals.userEmail;

  const columns = [
    {
      title: "Nombre de la reunión",
      dataIndex: "title_meeting",
      key: "title_meeting",
      render: (_, record) => {
        //navigate to template detail
        return (
          (record.statusId === MEETING_STATUS.EN_EJECUCION || record.statusId === MEETING_STATUS.FINALIZADA) ? <Link to={`/meeting/${record.id}/execute`}>{record.title_meeting}</Link> : <Link to={`/meeting/${record.id}`}>{record.title_meeting}</Link>
        )
      }
    },
    {
      title: "Tipo de reunión",
      dataIndex: "meeting_type_name",
      key: "meeting_type_name",
    },
    {
      title: "Departamento",
      dataIndex: "department_name",
      key: "department",
    },
    {
      title: "Fecha",
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => formatTimestamp(record.startDate),
    },
    {
      title: "Porcentaje de éxito",
      dataIndex: "SuccessRate",
      key: "SuccessRate",
      render: (_, record) => {
       if (record.success_rate === null){
         return "N/A"
       }
        return (
            record.success_rate + " %"
          )
      },
    },
    {
      title: "Porcentaje de cumplimiento",
      dataIndex: "ImplementationRate",
      key: "ImplementationRate",
      render: (_, record) => {
        if (record.implementation_rate === null){
          return "N/A"
        }
        return (
            record.implementation_rate + " %"
        )
      },
    },
    // {
    //   title: "Opciones",
    //   key: "actions",
    //   width: 80,
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Dropdown
    //         trigger={["click"]}
    //         menu={{
    //           items:[
    //             {
    //               key: '0',
    //               label: (record.statusId === MEETING_STATUS.ABIERTA) ? 'Ejecutar reunión' : 'Ver Reunión',
    //               icon:<PlayCircleOutlined />,
    //               onClick: () => handleActionClick("execute", record)
    //             },
    //             ...(record.statusId === MEETING_STATUS.ABIERTA ? [{
    //               key: '1',
    //               label: 'Ver puntos',
    //               icon:<UnorderedListOutlined />,
    //               onClick: () => handleActionClick("points", record)
    //             },] : []),
    //             {
    //               key: '2',
    //               label: 'Editar',
    //               icon:<EditOutlined />,
    //               onClick: () => handleActionClick("edit", record)
    //             },
    //             {
    //               key: '3',
    //               label: 'Cancelar',
    //               icon:<DeleteOutlined />,
    //               onClick: () => handleActionClick("delete", record)
    //             },
    //           ],
    //         }}
    //       >
    //         <Button icon={<DownOutlined />} shape="circle" />
    //       </Dropdown>
    //     </Space>
    //   ),
    // },
  ];

  const fetchData = useCallback(
    async (newPagination, search) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));

        let params = {
            page,
            limit: pageSize,
            search: search,
            statusId: 3,
            user: userEmail,
          }
        // if (userRole.toLowerCase() === "user") {
        //   params.user = userEmail;
        // }
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting`,
          {
            headers: {
              "x-token": globals.token,
            },
            params,
          }
        );
        if (response.data.status !== 0){
          setLoading(false);
          return;
        }
        console.log("Meetings:", response.data.data.rows);
        setData(response?.data?.data?.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data?.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data?.count,
          }
          );
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.log("Error fetching data:", error.response);
        if (error?.response?.data?.status !== -3) {
          console.error("Error fetching data:", error.response);
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
        else{
          notification.warning({
            message: "No hay reuniones disponibles!",
            placement: "bottomRight",
            duration: 2,
          });
        
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchData(null, null);
  }, [fetchData]);

  async function handleTableChange(newPagination) {
    fetchData(newPagination);
  }

  const saveMeetingForm = async ({status, newMeeting}) => {
    setShowMeetingForm(false);
    if (isEdit) {
      setIsEdit(false);
      if (status === "edited") {
        notification.success({
          message: "Reunión editada exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      }
      else if (status === "bulk-edited") {
        notification.success({
          message: "Reuniones editadas exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
        fetchData(null);
      }
      return;
    }
    if(status === "created"){
      console.log("New meeting:", newMeeting);
      setData([...newMeeting, ...data]);
    }

    notification.success({
      message: "Reunión creada exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });
  };

  const closeMeetingForm = () => {
    setShowMeetingForm(false);
    setIsEdit(false);
    setCurrentMeeting(null);
  };

  const deleteMeeting = async (delete_option) => {
    setMessageVisible(false);
    setLoading(true);
    const params = {
      delete_option,
    };
    
    try{
      const response = await axios.put(`${globals.SERVICE_API_DB}/v1/cancel-meeting/${currentMeeting.id}`,
      null,
      {
        headers: {
          "x-token": globals.token,
        },
        params
      });
      console.log("Meeting deleted:", response.data);
      setLoading(false);
      fetchData(null);
      notification.success({
        message: "Reunión cancelada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    }
    catch(err){
      setLoading(false);
      console.log(err.response.data);
      if (err.response.data.status === -1){
        notification.error({
          message: "No puedes cancelar estas reuniones, porque algunas ya han ocurrido",
          placement: "bottomRight",
          duration: 2,
        });
      }
      else{
        notification.error({
          message: "Error cancelando reunión",
          placement: "bottomRight",
          duration: 2,
        });
      }
      return;
    }
  };

  const handleRefresh = () => {
    fetchData(null);
  };

  const handleSearch = async () => {
    fetchData(null, searchText);
  };

  const handleSearchEnterKey = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h2 style={{ marginRight: "16px" }}>Listado Reuniones cerradas</h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={() => {
            setIsEdit(false);
            setShowMeetingForm(true);
          }}
          style={{ marginRight: "8px" }}
        >
          Crear
        </Button>
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Input
        placeholder="Buscar"
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16, width: 200 }}
        prefix={<SearchOutlined />}
        onKeyDown={handleSearchEnterKey}
      />
      <Button onClick={handleSearch} style={{ marginRight: "8px" }}>
        Buscar
      </Button>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />

      <MeetingForm
        open={showMeetingForm}
        onFinish={saveMeetingForm}
        onCancel={closeMeetingForm}
        isEdit={isEdit}
        currentMeeting={currentMeeting}
      />

      <DeleteMeetingDialog
        visible={messageVisible}
        title="Está seguro de cancelar esta reunión?"
        message="Esta acción no se puede deshacer."
        onOk={deleteMeeting}
        onCancel={() => setMessageVisible(false)}
        currentMeeting={currentMeeting}
      />
    </div>
  );
};

export default ClosedMeetingList;
